// This is for caching the blob urls
export const existingImageUrls = new Map<string, Promise<Blob | null>>();
